import { connect } from 'react-redux';

import {
  MobileFullScreenGallery,
  IMobileFullScreenGalleryStateProps,
} from '../../components/mobile/MobileFullScreenGallery';
import { getSlides } from '../../selectors/fotorama';
import { IState } from '../../store';

export function mapStateToProps(state: IState): IMobileFullScreenGalleryStateProps {
  return {
    neighbourhoodList: state.villageData.village.neighbourhoodList ?? [],
    slides: getSlides(state),
  };
}

export const MobileFullScreenGalleryContainer = connect(mapStateToProps)(MobileFullScreenGallery);
